<template>
  <div>
    <Loading v-if="loading" />

    <v-sheet
      v-else-if="item.hours && item.team"
      color="#FAFAFA"
      class="py-10 py-sm-12 py-md-14 py-lg-16 overflow-hidden"
    >
      <v-container>
        <PagesTitle :mod="mod">Horários e Equipe Assistencial</PagesTitle>

        <v-row justify="center" class="mx-0 mx-sm-n3 mt-10">
          <v-col cols="12" lg="10">
            <v-row justify="center" class="relative items">
              <img src="/img/bg/vertical.png" class="bg-vertical" />
              <img src="/img/bg/horizontal.png" class="bg-horizontal" />

              <v-col
                cols="12"
                md="6"
                class="d-flex align-start primary px-5 py-10 relative item"
                height="100%"
              >
                <div class="relative">
                  <v-icon color="white" size="58"> far fa-clock </v-icon>
                </div>

                <div class="ml-5 relative item-caption">
                  <div
                    class="
                      white--text
                      text-h5 text-md-h4
                      font-weight-medium
                      item-title
                    "
                  >
                    Horários
                    <v-sheet color="white" width="40px" height="2px"></v-sheet>
                  </div>

                  <div
                    v-html="item.hours"
                    class="text-caption white--text item-text mt-5"
                  ></div>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="
                  d-flex
                  align-start
                  primary
                  lighten-2
                  px-5
                  py-10
                  relative
                  item
                "
                height="100%"
              >
                <v-icon color="white" size="58"> fa-user-friends </v-icon>

                <div class="ml-5 item-caption">
                  <div
                    class="
                      white--text
                      text-h5 text-md-h4
                      font-weight-medium
                      item-title
                    "
                  >
                    Equipe
                    <v-sheet color="white" width="40px" height="2px"></v-sheet>
                  </div>

                  <div class="text-caption white--text mt-5 item-text">
                    {{ item.team }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import Loading from "../widgets/Loading.vue";
import PagesTitle from "../widgets/PagesTitle.vue";

const _config = {
  mod: "pages-informations-contacts",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    item: {},
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style lang="scss" scoped>
.items {
  .bg-horizontal {
    position: absolute;
    right: -30px;
    top: -30px;
  }
  .bg-vertical {
    bottom: -30px;
    left: -30px;
    position: absolute;
  }
  .item {
    &:nth-child(odd) {
      border-radius: 18px 0 0 18px;
      @media screen and (max-width: 960px) {
        border-radius: 18px 18px 0 0;
      }
    }
    &:nth-child(even) {
      border-radius: 0 18px 18px 0;
      @media screen and (max-width: 960px) {
        border-radius: 0 0 18px 18px;
      }
    }
    .item-title {
      line-height: 58px;
    }
  }
}
</style>
